import React, { useState } from 'react';
import axios from 'axios';

const WhatsAppSender = () => {
    const [contacts, setContacts] = useState([
        { name: 'Anisha Patil', mobile: '7248970994', paidFee: 100, dueDate: '2023-12-01', remainingFee: 50, selected: false },
        { name: 'Megha Mokashi', mobile: '8421586414', paidFee: 200, dueDate: '2023-11-15', remainingFee: 0, selected: true },
        // Add more contacts as needed
    ]);
    const [response, setResponse] = useState(null);
    const [selectAll, setSelectAll] = useState(false);

    const handleSelectAll = () => {
        const updatedContacts = contacts.map(contact => ({ ...contact, selected: !selectAll }));
        setContacts(updatedContacts);
        setSelectAll(!selectAll);
    };

 const handleSendMessages = async () => {
    const baseUrl = `${process.env.REACT_APP_WHAT_API}`;
    const selectedContacts = contacts.filter(contact => contact.selected);

    try {
        const promises = selectedContacts.map(async ({ mobile, name, paidFee, dueDate, remainingFee }) => {
            // Ensure mobile number is in the correct format
            const formattedMobile = mobile.startsWith('91') ? mobile : `91${mobile}`; // Example for India
            
            // Construct the message
            const message = `feereminder,${name},${paidFee},${dueDate},${remainingFee}`;
            const url = `${baseUrl}?number=${formattedMobile}&message=${encodeURIComponent(message)}`;
            console.log(`Sending to ${url}`);
            const res = await axios.get(url);
            console.log('Response:', res.data);
            return res.data;
        });

        const results = await Promise.all(promises);
        setResponse(results);
    } catch (error) {
        console.error('Error sending messages:', error.response?.data || error.message);
        setResponse({ error: 'Failed to send messages' });
    }
};


    return (
        <div className='main-content-of-page p-5'>
            <h1>Send Messages</h1>
            <table>
                <thead>
                    <tr>
                        <th>
                            <input
                                type="checkbox"
                                checked={selectAll}
                                onChange={handleSelectAll}
                            />
                        </th>
                        <th>Name</th>
                        <th>Mobile Number</th>
                        <th>Paid Fee</th>
                        <th>Due Date</th>
                        <th>Remaining Fee</th>
                    </tr>
                </thead>
                <tbody>
                    {contacts.map((contact, index) => (
                        <tr key={index}>
                            <td>
                                <input
                                    type="checkbox"
                                    checked={contact.selected}
                                    onChange={() => {
                                        const updatedContacts = [...contacts];
                                        updatedContacts[index].selected = !updatedContacts[index].selected;
                                        setContacts(updatedContacts);
                                    }}
                                />
                            </td>
                            <td>{contact.name}</td>
                            <td>{contact.mobile}</td>
                            <td>{contact.paidFee}</td>
                            <td>{contact.dueDate}</td>
                            <td>{contact.remainingFee}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <button onClick={handleSendMessages}>Send Messages</button>

            {response && (
                <div>
                    <h2>Response:</h2>
                    <pre>{JSON.stringify(response, null, 2)}</pre>
                </div>
            )}
        </div>
    );
};

export default WhatsAppSender;
